import Vue from 'vue'
import VueRouter from 'vue-router'
import Page from '../views/page.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  // base: import.meta.env.VUE_PUBLICPATH_URL,
  base:process.env.VUE_PUBLICPATH_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Page
    },
    {
      path:'/playBack',
      name:'playBack',
      component:()=>import('../views/playBackList.vue')
    },
    {
      path:'/test',
      name:'test',
      component:()=>import('../views/test.vue')
    },
    {
      path:'/uniVideo',
      name:'uniVideo',
      component:()=>import('../views/uniVideo.vue')
    }
  ]
})

export default router
